import { render, staticRenderFns } from "./GenericInvoicePreview.vue?vue&type=template&id=4f12c4c6&scoped=true&"
import script from "./GenericInvoicePreview.vue?vue&type=script&lang=js&"
export * from "./GenericInvoicePreview.vue?vue&type=script&lang=js&"
import style0 from "./GenericInvoicePreview.vue?vue&type=style&index=0&id=4f12c4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12c4c6",
  null
  
)

export default component.exports